module.exports = __webpack_public_path__ + "static/img/customerLoginBG.2866036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customerLoginBG.jpg
// module id = 439
// module chunks = 169